import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import {
  GetToolAnalyticsParams,
  ListToolAnalyticsResponse,
  ShowToolAnalyticsResponse,
} from "./types";

export * from "./types";

const ENDPOINTS = {
  LIST: "/api/v2/admin/tool-analytics",
  SHOW: "/api/v2/admin/tool-analytics/:tool_name",
};

export class ToolAnalyticsAPI {
  constructor(private client: CohesiveAPIClient) {}

  async list(
    params: GetToolAnalyticsParams = {},
    config?: AxiosRequestConfig,
  ): Promise<ListToolAnalyticsResponse> {
    const searchParams = new URLSearchParams();

    if (params.after_ts) searchParams.append("after_ts", params.after_ts);
    if (params.before_ts) searchParams.append("before_ts", params.before_ts);
    if (params.has_errors !== undefined)
      searchParams.append("has_errors", String(params.has_errors));
    if (params.min_executions)
      searchParams.append("min_executions", String(params.min_executions));
    if (params.sort_by) searchParams.append("sort_by", params.sort_by);
    if (params.platform_name)
      searchParams.append("platform_name", params.platform_name);
    if (params.organization_id)
      searchParams.append("organization_id", params.organization_id);
    if (params.user_id) searchParams.append("user_id", params.user_id);
    if (params.paying_orgs_only !== undefined)
      searchParams.append("paying_orgs_only", String(params.paying_orgs_only));

    const url = `${ENDPOINTS.LIST}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    const response = await this.client.axios.get<ListToolAnalyticsResponse>(
      url,
      config,
    );
    return response.data;
  }

  async getByToolName(
    toolName: string,
    params: { after_ts?: string; before_ts?: string } = {},
    config?: AxiosRequestConfig,
  ): Promise<ShowToolAnalyticsResponse> {
    const searchParams = new URLSearchParams();

    if (params.after_ts) searchParams.append("after_ts", params.after_ts);
    if (params.before_ts) searchParams.append("before_ts", params.before_ts);

    const url = ENDPOINTS.SHOW.replace(
      ":tool_name",
      encodeURIComponent(toolName),
    );
    const fullUrl = `${url}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    const response = await this.client.axios.get<ShowToolAnalyticsResponse>(
      fullUrl,
      config,
    );
    return response.data;
  }
}
